import State from 'store/State';

import { AggregationField } from '../../aggregation/fields/aggregationFieldPortfolio';
import {
    PortfolioSummaryAggregatedData,
    PortfolioSummaryDataState,
} from '../data/PortfolioSummaryDataState';
import { useSelector } from 'react-redux';
import { PortfolioSummaryDrillDown } from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';
import { selectWidgetsDataState } from 'widgets/store/selectors';

export const selectPortfolioSummaryDataState: (
    state: State
) => PortfolioSummaryDataState | undefined = (state) => {
    return selectWidgetsDataState(state).portfolio;
};

export const selectPortfolioSummaryAggregationFields: (
    state: State
) => AggregationField[] = (state) => {
    const aggregations = selectPortfolioSummaryDataState(state)?.aggregatedData;
    return aggregations
        ? (Object.keys(aggregations) as AggregationField[])
        : [];
};

/*
 * Select the aggregated data for a field.
 */
export const selectPortfolioSummaryAggregatedData: (
    state: State,
    aggregationField: AggregationField
) => PortfolioSummaryAggregatedData | undefined = (state, aggregationField) => {
    const data = selectPortfolioSummaryDataState(state);
    return data?.aggregatedData
        ? data.aggregatedData[aggregationField]
        : undefined;
};

/*
 * Returns the aggregated drilldown data for a aggregation field and drilldown
 */
export const selectPortfolioSummaryAggregatedDataDrillDown: (
    state: State,
    aggregationField: AggregationField,
    drillDown: PortfolioSummaryDrillDown
) => PortfolioSummaryAggregatedData | undefined = (
    state,
    aggregationField,
    drillDown
) => {
    const { groupName: drillDownGroupName, aggregationField: drillDownField } =
        drillDown;

    const aggregatedData = selectPortfolioSummaryAggregatedData(
        state,
        aggregationField
    );

    const aggregatedDataGroup = aggregatedData?.[drillDownGroupName];
    return aggregatedDataGroup?.drillDowns?.[drillDownField];
};

export const selectPortfolioSummaryStreamingAggregationFields: (
    state: State
) => AggregationField[] = (state) => {
    const data = selectPortfolioSummaryDataState(state);
    return data?.streamingAggregationFields || [];
};

export const useSelectPortfolioSummaryAggregatedData = (
    aggregationField: AggregationField
) =>
    useSelector((state: State) =>
        selectPortfolioSummaryAggregatedData(state, aggregationField)
    );
